import { gql } from "@apollo/client";

const ADD_PRODUCT = gql `
mutation AddProductBusiness($sbuId: ID!, $productId: ID!, $code: String!, $urlSlug: String!, $useQtyPricing: Boolean, $transferRule: String, $isAvailable: Boolean, $altTitle: String, $altDescription: String, $altBasePrice: Decimal, $accountRequired: Boolean, $description: String, $basePrice: Decimal, $categoryId: ID!, $title: String!, $isProductOwner: Boolean = false, $note: String = "", $username: String = "") {
  addProductBusiness(
    productBusiness: {productId: $productId, sbuId: $sbuId, code: $code, urlSlug: $urlSlug, useQtyPricing: $useQtyPricing, transferRule: $transferRule, isAvailable: $isAvailable, altTitle: $altTitle, altDescription: $altDescription, altBasePrice: $altBasePrice, accountRequired: $accountRequired}
    product: {categoryId: $categoryId, title: $title, description: $description, basePrice: $basePrice}
    productManager: {isProductOwner: $isProductOwner, note: $note, username: $username}
  ) {
    success
    errors
    productBusiness {
      id
      code
      altTitle
      altDescription
      altBasePrice
      accountRequired
      isAvailable
      transferRule
      urlSlug
      useQtyPricing
      
      product {
        uuid
        title
        description
        basePrice
        createdAt
        updatedAt
        category {
          id
          name
          physicalProduct
          description
        }
      }
      prices {
        id
        isActive
        maxQuantity
        minQuantity
        price
        datePriceModified
        datePriceAdded
      }
    }
 productManager{
  uuid
  manager{
    username
    firstName
    lastName
  }
  isProductOwner
  note
}
  }
}
`
const UPDATE_PRODUCT = gql`
mutation UpdateProductBusiness($id:ID!, $sbuId: ID!, $productId: ID!, $code: String!, $urlSlug: String!, $useQtyPricing: Boolean, $transferRule: String, $isAvailable: Boolean, $altTitle: String, $altDescription: String, $altBasePrice: Decimal, $accountRequired: Boolean, $description: String, $basePrice: Decimal, $categoryId: ID!, $title: String!, $isProductOwner: Boolean = false, $note: String = "", $username: String = "") {
  updateProductBusiness(
    productBusiness: {id:$id, productId: $productId, sbuId: $sbuId, code: $code, urlSlug: $urlSlug, useQtyPricing: $useQtyPricing, transferRule: $transferRule, isAvailable: $isAvailable, altTitle: $altTitle, altDescription: $altDescription, altBasePrice: $altBasePrice, accountRequired: $accountRequired}
    product: {categoryId: $categoryId, title: $title, description: $description, basePrice: $basePrice}
    productManager: {isProductOwner: $isProductOwner, note: $note, username: $username}
  ) {
    success
    errors
    productBusiness {
      id
      code
      altTitle
      altDescription
      altBasePrice
      accountRequired
      isAvailable
      transferRule
      urlSlug
      useQtyPricing
      
      product {
        uuid
        title
        description
        basePrice
        createdAt
        updatedAt
        category {
          id
          name
          physicalProduct
          description
        }
      }
      prices {
        id
        isActive
        maxQuantity
        minQuantity
        price
        datePriceModified
        datePriceAdded
      }
    }
 productManager{
  uuid
  manager{
    username
    firstName
    lastName
  }
  isProductOwner
  note
}
  }
}
`

const ADD_PRODUCT_OPTION_GROUP = gql`
  mutation AddProductOptionGroup($productId: ID!, $name: String!, $isRequired: Boolean = false, $minSelections: Int = 0, $maxSelections: Int = 1, $ordering: Int = 1, $isActive: Boolean = true) {
    addProductOptionGroup(
      productOptionGroup: { productId: $productId, name: $name, isRequired: $isRequired, minSelections: $minSelections, maxSelections: $maxSelections, ordering: $ordering, isActive: $isActive }
    ) {
      success
      errors
      productOptionGroup {
        id
        name
        isRequired
        minSelections
        maxSelections
        ordering
        isActive
      }
    }
  }
`;

const UPDATE_PRODUCT_OPTION_GROUP = gql`
  mutation UpdateProductOptionGroup($id: ID!, $name: String!, $isRequired: Boolean = false, $minSelections: Int = 0, $maxSelections: Int = 1, $ordering: Int = 1, $isActive: Boolean = true) {
    updateProductOptionGroup(
      productOptionGroup: { id: $id, name: $name, isRequired: $isRequired, minSelections: $minSelections, maxSelections: $maxSelections, ordering: $ordering, isActive: $isActive }
    ) {
      success
      errors
      productOptionGroup {
        id
        name
        isRequired
        minSelections
        maxSelections
        ordering
        isActive
      }
    }
  }
`;

const ADD_PRODUCT_OPTION = gql`
  mutation AddProductOption($groupId: ID!, $label: String!, $pricePremium: Decimal = 0.0, $ordering: Int = 1, $isActive: Boolean = true) {
    addProductOption(
      productOption: { groupId: $groupId, label: $label, pricePremium: $pricePremium, ordering: $ordering, isActive: $isActive }
    ) {
      success
      errors
      productOptionGroup {
        id
        name
      }
      productOption {
        id
        label
        pricePremium
        onHand
        ordering
        isActive
      }
    }
  }
`;

const UPDATE_PRODUCT_OPTION = gql`
  mutation UpdateProductOption($id: ID!, $label: String!, $pricePremium: Decimal = 0.0, $ordering: Int = 1, $isActive: Boolean = true) {
    updateProductOption(
      productOption: { id: $id, label: $label, pricePremium: $pricePremium, ordering: $ordering, isActive: $isActive }
    ) {
      success
      errors
      productOption {
        id
        label
        pricePremium
        onHand
        ordering
        isActive
      }
    }
  }
`;

const ADJUST_PRODUCT_OPTION_INVENTORY = gql`
  mutation AdjustProductOptionInventory($productOptionId: ID!, $delta: Int!, $reason: String!, $note: String) {
    adjustProductOptionInventory(
      productOptionId: $productOptionId
      delta: $delta
      reason: $reason
      note: $note
    ) {
      success
      errors
      productOption {
        id
        label
        onHand
      }
      adjustment {
        id
        delta
        reason
        resultingOnHand
        note
        createdAt
        createdBy {
          displayName
          username
        }
      }
    }
  }
`;

const BATCH_FIELDS = `
  uuid
  status
  totalAmount
  currency
  periodStart
  periodEnd
  createdAt
  updatedAt
  approvedAt
  initiatedAt
  completedAt
  stripeTransferId
  notes
  sbuUser {
    id
    user {
      username
      firstName
      lastName
    }
  }
  approvedBy {
    id
    user {
      username
    }
  }
`;

const ASSEMBLE_PAYOUT_BATCH = gql`
  mutation AssemblePayoutBatch($periodStart: Date, $periodEnd: Date) {
    assemblePayoutBatch(input: { periodStart: $periodStart, periodEnd: $periodEnd }) {
      success
      errors
    }
  }
`;

const APPROVE_PAYOUT_BATCH = gql`
  mutation ApprovePayoutBatch($batchId: ID!) {
    approvePayoutBatch(input: { batchId: $batchId }) {
      success
      errors
      payoutBatch {
        ${BATCH_FIELDS}
      }
    }
  }
`;

const INITIATE_PAYOUT_BATCH_TRANSFER = gql`
  mutation InitiatePayoutBatchTransfer($batchId: ID!) {
    initiatePayoutBatchTransfer(input: { batchId: $batchId }) {
      success
      errors
      payoutBatch {
        ${BATCH_FIELDS}
      }
    }
  }
`;

export {
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  ASSEMBLE_PAYOUT_BATCH,
  APPROVE_PAYOUT_BATCH,
  INITIATE_PAYOUT_BATCH_TRANSFER,
  ADD_PRODUCT_OPTION_GROUP,
  UPDATE_PRODUCT_OPTION_GROUP,
  ADD_PRODUCT_OPTION,
  UPDATE_PRODUCT_OPTION,
  ADJUST_PRODUCT_OPTION_INVENTORY,
}